export const DISABLE_PUFF = 'DISABLE_PUFF';
export const COUNT_PUFF = 'COUNT_PUFF';
export const TIME_PUFF = 'TIME_PUFF';
